import { cacheFirstConfig, http } from '@/core/helpers/http.helper';
import { ApiResource } from '@/core/models/api-resource.interface';
import { WorkExperienceType } from './work-experience-type.interface';

export class WorkExperienceTypeService {
   async getWorkExperienceTypes() {
      const response = await http.get<ApiResource<Array<WorkExperienceType>>>(`/work-experience-types`, {
         ...cacheFirstConfig,
      });
      return response.data;
   }

   async getWorkExperienceType() {
      throw Error('Method not implemented');
   }

   async postWorkExperienceType() {
      throw Error('Method not implemented');
   }

   async putWorkExperienceType() {
      throw Error('Method not implemented');
   }

   async deleteWorkExperienceType() {
      throw Error('Method not implemented');
   }
}
